export interface Category {
  id: string;
  nameKey: string;
  url: string;
  image: string;
}

export interface Guide {
  id: string;
  nameKey: string;
  path: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'cat_shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20crisp%20white%20leather%20sneakers%20on%20a%20concrete%20city%20street%2C%20morning%20sunlight%20casting%20soft%20shadows%2C%20urban%20editorial%20product%20photography%2C%20clean%20fresh%20streetwear%20aesthetic%2C%20sharp%20details%2C%20pastel%20sky%20reflection&width=600&height=600&seq=cat-shoes-1&orientation=squarish&nocache=true',
  },
  {
    id: 'hoodies',
    nameKey: 'cat_hoodies',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20beige%20oversized%20hoodie%20folded%20on%20a%20warm%20oak%20wooden%20bench%2C%20soft%20window%20light%2C%20cozy%20minimalist%20Scandinavian%20interior%2C%20premium%20cotton%20texture%20visible%2C%20editorial%20clothing%20photography%2C%20neutral%20earth%20tones&width=600&height=600&seq=cat-hoodies-1&orientation=squarish&nocache=true',
  },
  {
    id: 'tshirts',
    nameKey: 'cat_tshirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    image: 'https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20colorful%20cotton%20t-shirts%20in%20pastel%20pink%20mint%20and%20cream%20arranged%20on%20a%20light%20linen%20surface%2C%20bright%20airy%20daylight%2C%20fresh%20summer%20mood%2C%20clean%20minimal%20product%20photography%2C%20soft%20fabric%20folds%20visible&width=600&height=600&seq=cat-tshirts-1&orientation=squarish&nocache=true',
  },
  {
    id: 'jackets',
    nameKey: 'cat_jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20brown%20leather%20jacket%20hanging%20on%20a%20black%20metal%20rack%20against%20a%20muted%20charcoal%20wall%2C%20moody%20cinematic%20lighting%20with%20a%20single%20warm%20spotlight%2C%20premium%20outerwear%20editorial%20photography%2C%20rich%20leather%20grain%20detail&width=600&height=600&seq=cat-jackets-1&orientation=squarish&nocache=true',
  },
  {
    id: 'pants',
    nameKey: 'cat_pants',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20faded%20blue%20denim%20jeans%20and%20beige%20cargo%20pants%20neatly%20folded%20on%20a%20white%20marble%20table%2C%20soft%20natural%20side%20light%2C%20casual%20streetwear%20flat%20lay%2C%20clean%20modern%20product%20photography%2C%20subtle%20texture%20detail&width=600&height=600&seq=cat-pants-1&orientation=squarish&nocache=true',
  },
  {
    id: 'headwear',
    nameKey: 'cat_headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20stylish%20baseball%20caps%20and%20a%20knitted%20beanie%20in%20muted%20olive%20rust%20and%20cream%20tones%20arranged%20on%20a%20light%20grey%20surface%2C%20soft%20diffused%20daylight%2C%20urban%20streetwear%20accessories%20photography%2C%20clean%20fresh%20look&width=600&height=600&seq=cat-headwear-1&orientation=squarish&nocache=true',
  },
  {
    id: 'sets',
    nameKey: 'cat_sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    image: 'https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20tracksuit%20set%20in%20sage%20green%20laid%20flat%20on%20a%20white%20background%20with%20subtle%20shadows%2C%20athletic%20leisurewear%20editorial%20photography%2C%20clean%20minimal%20style%2C%20premium%20fabric%20texture%2C%20bright%20even%20lighting&width=600&height=600&seq=cat-sets-1&orientation=squarish&nocache=true',
  },
  {
    id: 'underwear',
    nameKey: 'cat_underwear',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    image: 'https://readdy.ai/api/search-image?query=Soft%20premium%20cotton%20underwear%20basics%20in%20white%20grey%20and%20black%20folded%20neatly%20on%20a%20pale%20blue%20surface%2C%20gentle%20morning%20light%2C%20clean%20minimal%20essentials%20photography%2C%20delicate%20fabric%20texture%2C%20calm%20fresh%20aesthetic&width=600&height=600&seq=cat-underwear-1&orientation=squarish&nocache=true',
  },
  {
    id: 'jersey',
    nameKey: 'cat_jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20football%20soccer%20jersey%20in%20red%20and%20white%20with%20detailed%20stitching%20laid%20flat%20on%20a%20green%20pitch%20background%2C%20dynamic%20sportswear%20product%20photography%2C%20crisp%20daylight%2C%20athletic%20energy%2C%20high%20detail%20fabric%20weave&width=600&height=600&seq=cat-jersey-1&orientation=squarish&nocache=true',
  },
  {
    id: 'accessories',
    nameKey: 'cat_accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20wristwatch%20with%20a%20leather%20strap%20next%20to%20sleek%20sunglasses%20on%20a%20warm%20terracotta%20ceramic%20plate%2C%20golden%20hour%20light%2C%20elegant%20fashion%20accessories%20flat%20lay%2C%20refined%20editorial%20photography%2C%20rich%20warm%20tones&width=600&height=600&seq=cat-accessories-1&orientation=squarish&nocache=true',
  },
  {
    id: 'bags',
    nameKey: 'cat_bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    image: 'https://readdy.ai/api/search-image?query=A%20tan%20leather%20backpack%20and%20a%20structured%20handbag%20placed%20on%20a%20stone%20bench%20in%20a%20sunlit%20urban%20plaza%2C%20soft%20daylight%20with%20gentle%20shadows%2C%20premium%20bag%20editorial%20photography%2C%20warm%20neutral%20palette%2C%20crisp%20details&width=600&height=600&seq=cat-bags-1&orientation=squarish&nocache=true',
  },
  {
    id: 'belts',
    nameKey: 'cat_belts',
    url: 'https://kaspreadsheet.com/category-922-Belts.html',
    image: 'https://readdy.ai/api/search-image?query=A%20coiled%20black%20and%20brown%20leather%20belt%20with%20a%20brass%20buckle%20on%20a%20dark%20walnut%20wood%20surface%2C%20dramatic%20side%20lighting%2C%20luxury%20leather%20accessory%20close%20up%20photography%2C%20rich%20texture%20and%20metallic%20shine%2C%20elegant%20moody%20aesthetic&width=600&height=600&seq=cat-belts-1&orientation=squarish&nocache=true',
  },
  {
    id: 'perfumes',
    nameKey: 'cat_perfumes',
    url: 'https://kaspreadsheet.com/category-923-Perfumes.html',
    image: 'https://readdy.ai/api/search-image?query=An%20elegant%20glass%20perfume%20bottle%20with%20golden%20liquid%20and%20delicate%20floral%20accents%20on%20a%20soft%20blush%20pink%20silk%20background%2C%20dreamy%20romantic%20lighting%2C%20luxury%20fragrance%20product%20photography%2C%20refined%20airy%20aesthetic&width=600&height=600&seq=cat-perfumes-1&orientation=squarish&nocache=true',
  },
  {
    id: 'other',
    nameKey: 'cat_other',
    url: 'https://kaspreadsheet.com',
    image: 'https://readdy.ai/api/search-image?query=An%20eclectic%20assortment%20of%20trendy%20streetwear%20items%20including%20a%20cap%20chain%20wallet%20and%20small%20gadget%20neatly%20arranged%20on%20a%20mint%20green%20background%2C%20playful%20colorful%20flat%20lay%2C%20clean%20product%20photography%2C%20cheerful%20fresh%20mood&width=600&height=600&seq=cat-other-1&orientation=squarish&nocache=true',
  },
];

export const guides: Guide[] = [
  {
    id: 'review',
    nameKey: 'guide_review',
    path: '/cssbuy-review/',
    image: 'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20hovering%20over%20a%20neat%20desk%20with%20review%20notes%20and%20a%20five%20star%20rating%20card%2C%20bright%20clean%20workspace%2C%20professional%20analysis%20concept%20photography%2C%20fresh%20minimal%20editorial%20style%2C%20soft%20natural%20light&width=400&height=400&seq=guide-review-1&orientation=squarish',
  },
  {
    id: 'shipping',
    nameKey: 'guide_shipping',
    path: '/cssbuy-shipping-cost/',
    image: 'https://readdy.ai/api/search-image?query=A%20neat%20cardboard%20parcel%20box%20with%20shipping%20tape%20and%20a%20label%20on%20a%20bright%20table%20next%20to%20a%20small%20scale%2C%20logistics%20and%20delivery%20concept%2C%20clean%20airy%20product%20photography%2C%20fresh%20minimal%20style%2C%20soft%20daylight&width=400&height=400&seq=guide-shipping-1&orientation=squarish',
  },
  {
    id: 'coupon',
    nameKey: 'guide_coupon',
    path: '/cssbuy-coupon/',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20discount%20coupon%20ticket%20with%20scissors%20on%20a%20pastel%20yellow%20background%2C%20savings%20and%20promotion%20concept%2C%20cheerful%20clean%20flat%20lay%20photography%2C%20fresh%20minimal%20aesthetic%2C%20soft%20even%20lighting&width=400&height=400&seq=guide-coupon-1&orientation=squarish',
  },
  {
    id: 'discount',
    nameKey: 'guide_discount',
    path: '/cssbuy-discount-code/',
    image: 'https://readdy.ai/api/search-image?query=A%20bold%20percentage%20discount%20tag%20hanging%20on%20a%20shopping%20bag%20against%20a%20soft%20mint%20background%2C%20sale%20and%20deal%20concept%2C%20bright%20clean%20product%20photography%2C%20fresh%20modern%20retail%20aesthetic%2C%20soft%20shadows&width=400&height=400&seq=guide-discount-1&orientation=squarish',
  },
  {
    id: 'warehouse',
    nameKey: 'guide_warehouse',
    path: '/cssbuy-warehouse/',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20organized%20warehouse%20aisle%20with%20neatly%20stacked%20cardboard%20boxes%20on%20metal%20shelves%2C%20clean%20logistics%20and%20storage%20concept%2C%20airy%20industrial%20interior%2C%20fresh%20minimal%20photography%2C%20soft%20natural%20light&width=400&height=400&seq=guide-warehouse-1&orientation=squarish',
  },
  {
    id: 'legit',
    nameKey: 'guide_legit',
    path: '/cssbuy-legit/',
    image: 'https://readdy.ai/api/search-image?query=A%20green%20shield%20with%20a%20white%20checkmark%20resting%20on%20a%20clean%20white%20desk%20with%20a%20small%20lock%20icon%2C%20trust%20and%20safety%20verification%20concept%2C%20bright%20minimal%20product%20photography%2C%20fresh%20reassuring%20aesthetic%2C%20soft%20light&width=400&height=400&seq=guide-legit-1&orientation=squarish',
  },
  {
    id: 'qc',
    nameKey: 'guide_qc',
    path: '/cssbuy-qc/',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20hands%20inspecting%20a%20folded%20garment%20with%20a%20camera%20and%20check%20clipboard%20nearby%2C%20quality%20control%20inspection%20concept%2C%20bright%20clean%20workspace%2C%20fresh%20editorial%20photography%2C%20soft%20natural%20daylight&width=400&height=400&seq=guide-qc-1&orientation=squarish',
  },
  {
    id: 'beginner',
    nameKey: 'guide_beginner',
    path: '/cssbuy-beginner-guide/',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20rocket%20toy%20launching%20from%20an%20open%20notebook%20on%20a%20bright%20desk%20with%20a%20pencil%20and%20map%2C%20starting%20a%20journey%20concept%2C%20cheerful%20clean%20flat%20lay%20photography%2C%20fresh%20minimal%20editorial%20style%2C%20soft%20daylight&width=400&height=400&seq=guide-beginner-1&orientation=squarish',
  },
];

export const mainWebsiteUrl = 'https://kaspreadsheet.com';